export default {
  mytrials: 'Mis Estudios'

}